<script lang="ts">
  import type { Guide } from "../../types";
  import Sprite from "../sprite.svelte";
  import { guideChecklistPath } from "../../support/links";

  export let guide: Guide;

  $: title = guide.indexTitle;
  $: description = guide.indexDescription;

  $: spots = guide.spots;
</script>

<div class="Container">
  <div class="Content">
    {#if title}
      <h1 class="Title">{title}</h1>
    {/if}

    {#if description}
      <div class="Description">
        {@html description}
      </div>
    {/if}

    {#if spots.length > 0}
      <ul>
        {#each spots as spot (spot.id)}
          <li>
            <a href={guideChecklistPath(guide, { id: spot.id })}>
              {spot.title}
              <Sprite icon="icon-chevron-right" />
            </a>
          </li>
        {/each}
      </ul>
    {/if}
  </div>
</div>

<style>
  .Container {
    background: white;
    border-radius: 12px;
    box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.25);
    flex: 1 0;
    font-size: 16px;
    line-height: 1.4em;
    min-height: 100%;
    text-align: left;
    padding-top: 24px;
    width: 100%;
  }

  .Title {
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    padding: 24px 24px 0;
  }

  .Description {
    padding: 24px;
  }

  .Description :global(*:first-child) {
    margin-top: 0;
  }

  .Description :global(*:last-child) {
    margin-bottom: 0;
  }

  ul {
    font-size: 14px;
    border-top: 1px solid rgba(0, 0, 0, 0.2);
    list-style: none;
    margin: 0 24px;
    padding: 0;
  }

  li {
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    margin: 0;
    padding: 0;
  }

  a {
    align-items: center;
    display: flex;
    justify-content: space-between;
    min-height: 64px;
    padding: 16px 8px;
    text-decoration: none;
  }
</style>
